// What changed between the roles a company HAD when the form was opened and the roles now ticked. Only these are written: a role the user did not
// touch is never deleted and re-inserted, so a role added by somebody else (or by a bulk script) after the form was opened survives the save.
export function diffRoleIds(original: ReadonlySet<string>, selected: ReadonlySet<string>): { toAdd: string[]; toRemove: string[] } {
  return {
    toAdd: [...selected].filter(id => !original.has(id)),
    toRemove: [...original].filter(id => !selected.has(id)),
  }
}
